import photo1 from "./assets/photos/1.png"
import photo2 from "./assets/photos/2.png"
import photo3 from "./assets/photos/3.png"
import photo4 from "./assets/photos/4.png"
import photo5 from "./assets/photos/5.png"
import photo6 from "./assets/photos/6.png"
import photo7 from "./assets/photos/7.png"
import photo8 from "./assets/photos/8.png"
import photo9 from "./assets/photos/9.png"
import photo10 from "./assets/photos/10.png"
import photo11 from "./assets/photos/11.png"
import photo12 from "./assets/photos/12.png"
import { twMerge } from "tailwind-merge"
import { Button } from "./button"

const PHOTOS = [
  { src: photo1, width: 81, height: 106 },
  { src: photo2, width: 80, height: 106 },
  { src: photo3, width: 80, height: 106 },
  { src: photo4, width: 81, height: 106 },
  { src: photo5, width: 82, height: 106 },
  { src: photo6, width: 81, height: 106 },
  { src: photo7, width: 81, height: 106 },
  { src: photo8, width: 82, height: 106 },
  { src: photo9, width: 80, height: 105 },
  { src: photo10, width: 79, height: 105 },
  { src: photo11, width: 79, height: 105 },
  { src: photo12, width: 80, height: 105 },
]

const ROWS = [PHOTOS.slice(0, 4), PHOTOS.slice(4, 8), PHOTOS.slice(8, 12)]

interface Props {
  onClick: () => void
}

export function Photos({ onClick }: Props) {
  return (
    <div className="w-full bg-violet-190 px-4 text-white">
      <h2 className="font-quirk text-[28px] leading-[36px] tracking-[0.7px] -rotate-[2deg] px-2">
        We’ve found <span className="text-black">124,896 women</span> who are a
        perfect fit for you.
      </h2>

      <div className="mt-6 pb-4 flex flex-col gap-4">
        {ROWS.map((row, rowIndex) => {
          const rowRotation =
            rowIndex === 1 ? "rotate-[1deg]" : "-rotate-[1deg]"

          return (
            <div key={rowIndex} className={twMerge("flex gap-3", rowRotation)}>
              {row.map((photo, index) => {
                const offsetClass =
                  index === 1
                    ? "-translate-y-[3px]"
                    : index === 2
                      ? "translate-y-[3px]"
                      : ""

                return (
                  <div key={photo.src} className={`flex-1 ${offsetClass}`}>
                    <img
                      src={photo.src}
                      alt=""
                      width={photo.width}
                      height={photo.height}
                      className="w-full h-auto rounded-[8px] object-cover"
                    />
                  </div>
                )
              })}
            </div>
          )
        })}
      </div>
      <h2 className="mt-6 mb-8 font-quirk text-[32px] leading-[40px] tracking-[0.7px] -rotate-[4deg] px-2 text-right">
        Ready to see them?
      </h2>
      <div className="pb-6">
        <Button
          className="w-[240px] rotate-[6deg] ml-6"
          onClick={onClick}
          theme="white"
        >
          See results
        </Button>
      </div>
    </div>
  )
}
